module.exports = __webpack_public_path__ + "img/city8.28b7f94f.png";